const __RELATIVE_SOURCE_FILE__ /* __INJECTED__ */ = 'packages/patapp_web/src/store/patient.ts';
import Imm from 'immutable';
import {
    isLoading as patientLoading,
    selectPatientsImm as patients,
} from '@cistec/common_web/selectors/patientsSelectors';
import { useRemoteData } from '@cistec/common_web/hooks/useRemoteData';
import { getPatient } from 'App/actions/patient';
import { getPatNrFromSession } from 'App/utils/sessionStorage';
import { createSelector } from 'reselect';

const emptyMap = Imm.Map<string, any>();

export const selectPatient = createSelector(
    [patients, () => getPatNrFromSession()],
    (patients: Imm.Map<string, any>, patnr: string): Imm.Map<string, any> => {
        if (!patients) return emptyMap;
        return patients.get(patnr) || emptyMap;
    }
);

export function usePatientData(): any {
    const patnr = getPatNrFromSession();

    return useRemoteData({}, () => ({
        isLoading: patientLoading,
        select: selectPatient,
        shouldFetch: state => {
            const rec = selectPatient(state);
            return !patientLoading(state) && !!patnr && rec?.size === 0;
        },
        fetch: (dispatch, state) => {
            dispatch(getPatient(false, true));
        },
        noRefetch: true,
    }));
}
